import React, { useRef } from 'react';
import PremiumCollection from './PremiumCollection';

const RoomBrightening = () => {
  const whatWeOfferRef = useRef(null);
  
  const scrollToSection = () => {
    if (whatWeOfferRef.current) {
      whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="bg-gray-50 font-playfair text-gray-800">
      {/* Header Section */}
{/* <section
        className="text-center object-cover h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('images/roombr3.png')" }}
      >
  <div className="px-8 sm:px-16 lg:px-28">
          <h1 className="text-4xl md:text-7xl lg:text-8xl xl:text-9xl text-left text-[#462d2d] font-Montserrat uppercase font-semibold mb-4  pl-4 sm:pl-16 lg:pl-60 xl:pt-32 pt-60 ">
          ILLUMINATE
          </h1>

          <h1 className="text-4xl  md:text-7xl lg:text-8xl text-right font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pr-4 sm:pr-16 lg:pr-40 text-[#462d2d]">
          YOUR HOME
          </h1>
        </div>

        <div className=" mt-8 sm:mt-16 lg:mt-10 flex justify-center xl:pl-80">
          <button onClick={scrollToSection} className="text-white bg-[#462d2d] xl:text-xl xl:w-60 px-6 py-3 ">
            LEARN MORE
          </button>
        </div>
      </section> */}

<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-20 "
   style={{ backgroundImage: "url('images/roombr3.png')" }}
 >
  <div className="">
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#462d2d] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    ROOM 
    </h1>
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#462d2d] font-Montserrat uppercase  mb-4  lg:text-8xl">
      BRIGHTENING
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-white bg-[#462d2d] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>

{/* Content Section */}
<section className="py-16 px-2 md:px-6">
  <h2 ref={whatWeOfferRef} className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
    Transform Your Space with <br/>Motorized Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Experience the Magic of Room Brightening</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day gently with Aura shades that radiate a soft, natural glow. Perfect for early mornings before the sun rises, it’s a delightful way to wake up. 
        Gradual brightness simulates the sunrise, helping your body adjust naturally, making it easier to feel refreshed and energized.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/landing.png"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Cozy All Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Overcast or rainy day? No problem. Adjust the Aura light temperature to create a warm, relaxing ambiance that keeps you cozy no matter the weather. 
        Enjoy the perfect balance of comfort and lighting that adapts to your mood, whether you’re reading, working, or simply unwinding.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roombr2.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Enhance Evening Ambiance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Transform your evenings with Aura lights that let you adjust brightness from vibrant to dim, creating the perfect mood for relaxation or entertainment. 
        Whether hosting a dinner party or enjoying a quiet evening, customize the lighting to set the perfect tone for any occasion.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roombr4.jpeg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>


      <PremiumCollection />

      {/* Controls */}
      <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-16 p-6 lg:p-12">
        {/* Text Section */}
        <div className="flex-1 text-center lg:text-left space-y-4">
          <h2 className="text-2xl md:text-6xl font-semibold text-gray-800 text-center mb-8">
            Effortless Control
          </h2>
          <p className="text-base md:text-2xl text-gray-600">
            Experience cutting-edge home automation with <span className="font-semibold text-zinc-600">SSG Furnishing</span>’s Aura shades. Powered by our most advanced system, 
            <span className="font-semibold"> PowerView+™ Automation</span>, these shades are designed with reliability in mind, using a wired setup for consistent performance.
          </p>
          <p className="text-base md:text-2xl text-gray-600">
            Control Aura shades effortlessly through <span className="font-semibold">PowerView+ Automation</span> and the <span className="font-semibold">PowerView App</span>. Adjust shade positions, liner settings, light intensity, and even temperature — all at your fingertips whenever you desire.
          </p>
        </div>

        {/* Image Section */}
        <div className="flex-1">
          <img 
            src="images/smartcontrol1.jpg" 
            alt="Smart Control Image"
            className="w-full max-h-[500px] object-cover rounded-lg shadow-md"
          />
        </div>
      </div>

      <section className="relative bg-cover bg-center py-24 " style={{ backgroundImage: "url('images/roombri.jpeg') " }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Illuminate Your Home</h2>
          <p className="text-lg md:text-xl mb-8">
            Embrace the perfect blend of natural and smart lighting for a brighter, cozier living space.
          </p>
          <a
            href="/contact"
            className="inline-block bg-[#ac9b82] text-white font-semibold px-8 py-3  shadow-lg hover:bg-[#9e7f52] transition duration-300"
          >
            Request Your Free Quote
          </a>
        </div>
      </section>
    </div>
  );
};

export default RoomBrightening;
